import { ShouldRenderType } from 'components/Placement/types';

type QualitySectionProps = {
  shouldRender: ShouldRenderType;
  quality?: string | null;
};

export function QualitySection({
  shouldRender = () => false,
  quality = null,
}: Readonly<QualitySectionProps>) {
  const shouldRenderQuality = shouldRender('qualitySection.quality');

  if (!shouldRenderQuality) {
    return <div />;
  }

  return <>{quality ?? 'MSFT X'} PLACEMENT</>;
}
